import { IStoreState } from 'state/rootReducer';

export const getTransactionDrawerState = (state: IStoreState) =>
  state.records.transcriptionDrawer;

export const getPhysicianId = (state: IStoreState) =>
  state.userInfo.userData.physicianId;
